(function () {
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents == null) {
      return '0';
    }

    var precisionValue = typeof precision === 'undefined' ? 2 : precision;
    var thousandsSeparator = typeof thousands === 'undefined' ? ',' : thousands;
    var decimalSeparator = typeof decimal === 'undefined' ? '.' : decimal;
    var numString = (cents / 100).toFixed(precisionValue);
    var parts = numString.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSeparator);
    var centsPart = parts[1] ? decimalSeparator + parts[1] : '';

    return dollars + centsPart;
  }

  function formatMoney(cents, format) {
    if (!format) {
      return formatWithDelimiters(cents, 2, '.', ',') + ' €';
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/g;

    return format.replace(placeholderRegex, function (match, placeholder) {
      switch (placeholder) {
        case 'amount':
          return formatWithDelimiters(cents, 2);
        case 'amount_no_decimals':
          return formatWithDelimiters(cents, 0);
        case 'amount_with_comma_separator':
          return formatWithDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return formatWithDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return formatWithDelimiters(cents, 0, ' ');
        case 'amount_with_space_separator':
          return formatWithDelimiters(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return formatWithDelimiters(cents, 2, ' ', '.');
        default:
          return match;
      }
    });
  }

  function resolvePageUrl(path, shopOrigin) {
    var origin = (shopOrigin || window.location.origin || '').replace(/\/$/, '');

    if (!path) {
      return origin + '/pages/pauta';
    }

    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    return origin + (path.charAt(0) === '/' ? path : '/' + path);
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  }

  function initGeneradorPauta(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var catalogEl = document.getElementById(root.dataset.catalogId);
    if (!catalogEl) return;

    var catalog = [];
    try {
      catalog = JSON.parse(catalogEl.textContent);
    } catch (error) {
      return;
    }

    var config = {
      pautaPageUrl: resolvePageUrl(root.dataset.pautaPageUrl, root.dataset.shopOrigin),
      moneyFormat: root.dataset.moneyFormat || '{{amount}}€',
      placeholderLink: root.dataset.placeholderLink || '',
      copiedLabel: root.dataset.copiedLabel || 'Enlace copiado',
      copyLabel: root.dataset.copyLabel || 'Copiar enlace'
    };

    var selected = [];
    var chipsContainer = root.querySelector('[data-product-chips]');
    var selectedList = root.querySelector('[data-selected-list]');
    var discountInput = root.querySelector('[data-discount-input]');
    var linkField = root.querySelector('[data-link-field]');
    var copyBtn = root.querySelector('[data-copy-btn]');
    var utmInputs = root.querySelectorAll('[data-utm-input]');

    function getSelected(variantId) {
      return selected.find(function (item) {
        return String(item.variantId) === String(variantId);
      });
    }

    function renderChips() {
      if (!chipsContainer) return;

      chipsContainer.innerHTML = '';

      if (!catalog.length) {
        chipsContainer.innerHTML = '<p class="ru-generador-pauta__empty">No hay productos configurados en esta sección.</p>';
        return;
      }

      catalog.forEach(function (product) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ru-generador-pauta__product-chip';
        var chipSlug = product.slug || slugify(product.title);
        if (chipSlug) {
          button.classList.add('ru-generador-pauta__product-chip--' + chipSlug);
        }
        if (product.title && product.title.length > 14) {
          button.classList.add('ru-generador-pauta__product-chip--long');
        }
        if (product.halfWidth) {
          button.classList.add('ru-generador-pauta__product-chip--half');
        }
        if (getSelected(product.id)) {
          button.classList.add('is-selected');
        }
        button.textContent = product.title;
        button.dataset.variantId = product.id;
        button.addEventListener('click', function () {
          toggleProduct(product);
        });
        chipsContainer.appendChild(button);
      });
    }

    function toggleProduct(product) {
      var existing = getSelected(product.id);
      if (existing) {
        selected = selected.filter(function (item) {
          return String(item.variantId) !== String(product.id);
        });
      } else {
        selected.push({
          variantId: product.id,
          title: product.title,
          price: product.price,
          priceFormatted: product.priceFormatted,
          image: product.image,
          quantity: 1
        });
      }
      renderChips();
      renderSelected();
      updateLink();
    }

    function renderSelected() {
      if (!selectedList) return;

      selectedList.innerHTML = '';

      selected.forEach(function (item) {
        var card = document.createElement('div');
        card.className = 'ru-generador-pauta__selected-card';
        card.innerHTML =
          '<div class="ru-generador-pauta__selected-top">' +
            (item.image ? '<img class="ru-generador-pauta__selected-image" src="' + item.image + '" alt="" loading="lazy">' : '') +
            '<div class="ru-generador-pauta__selected-info">' +
              '<p class="ru-generador-pauta__selected-name">' + item.title + ' (' + item.priceFormatted + ')</p>' +
              '<p class="ru-generador-pauta__selected-qty-label">Cantidad: <span data-qty-label>' + item.quantity + '</span></p>' +
            '</div>' +
          '</div>' +
          '<div class="ru-generador-pauta__selected-actions">' +
            '<button type="button" class="ru-generador-pauta__remove-btn" data-remove>Eliminar</button>' +
            '<div class="ru-generador-pauta__qty-control">' +
              '<button type="button" class="ru-generador-pauta__qty-btn" data-decrease aria-label="Disminuir cantidad">' +
                '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
              '</button>' +
              '<span class="ru-generador-pauta__qty-value" data-qty-value>' + item.quantity + '</span>' +
              '<button type="button" class="ru-generador-pauta__qty-btn" data-increase aria-label="Aumentar cantidad">' +
                '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 1V11M1 6H11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>';

        card.querySelector('[data-remove]').addEventListener('click', function () {
          selected = selected.filter(function (entry) {
            return String(entry.variantId) !== String(item.variantId);
          });
          renderChips();
          renderSelected();
          updateLink();
        });

        card.querySelector('[data-decrease]').addEventListener('click', function () {
          if (item.quantity <= 1) return;
          item.quantity -= 1;
          card.querySelector('[data-qty-value]').textContent = item.quantity;
          card.querySelector('[data-qty-label]').textContent = item.quantity;
          updateLink();
        });

        card.querySelector('[data-increase]').addEventListener('click', function () {
          item.quantity += 1;
          card.querySelector('[data-qty-value]').textContent = item.quantity;
          card.querySelector('[data-qty-label]').textContent = item.quantity;
          updateLink();
        });

        selectedList.appendChild(card);
      });
    }

    function appendUtmParams(url) {
      utmInputs.forEach(function (input) {
        var name = input.dataset.utmInput;
        var value = input.value.trim();
        if (!name || !value) return;
        url += '&utm_' + name + '=' + encodeURIComponent(value);
      });

      return url;
    }

    function buildLink() {
      if (!selected.length || !discountInput || !discountInput.value.trim()) {
        return '';
      }

      var cart = selected
        .map(function (item) {
          return item.variantId + ':' + item.quantity;
        })
        .join(',');

      var discount = discountInput.value.trim();
      var baseUrl = config.pautaPageUrl.replace(/\/$/, '');
      var separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
      var link = baseUrl + separator + 'cart=' + cart + '&discount=' + encodeURIComponent(discount);

      return appendUtmParams(link);
    }

    function updateLink() {
      if (!linkField || !copyBtn) return;

      var link = buildLink();

      if (!link) {
        linkField.textContent = config.placeholderLink;
        linkField.classList.add('is-placeholder');
        linkField.dataset.url = '';
        copyBtn.disabled = true;
        return;
      }

      linkField.textContent = link;
      linkField.classList.remove('is-placeholder');
      linkField.dataset.url = link;
      copyBtn.disabled = false;
    }

    if (discountInput) {
      discountInput.addEventListener('input', updateLink);
    }

    utmInputs.forEach(function (input) {
      input.addEventListener('input', updateLink);
      input.addEventListener('change', updateLink);
      input.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        updateLink();
      });
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = linkField.dataset.url;
        if (!url) return;

        var originalLabel = copyBtn.querySelector('[data-copy-label]');
        var labelText = originalLabel || copyBtn;

        function markCopied() {
          if (originalLabel) {
            originalLabel.textContent = config.copiedLabel;
            window.setTimeout(function () {
              originalLabel.textContent = config.copyLabel;
            }, 2000);
          }
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(markCopied).catch(function () {
            window.prompt('Copia este enlace:', url);
          });
        } else {
          window.prompt('Copia este enlace:', url);
          markCopied();
        }
      });
    }

    renderChips();
    renderSelected();
    updateLink();
  }

  function boot() {
    document.querySelectorAll('[data-ru-generador-pauta]').forEach(initGeneradorPauta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ru-generador-pauta]');
    if (section) initGeneradorPauta(section);
  });
})();
